import { memo } from 'react'
import { cn } from '$components'
import { Dayjs } from 'dayjs'
import { ROW_OFFSET } from '$features/calendar/constants'
import { Slot, ScheduledPerson } from '$features/calendar/hooks/use-calendar-slots'
import { CalendarSlot } from './slot'

type SlotGrid = {
  slot: Slot
  key: string
  dayIndex: number
  groomerKey: number
  gridColumnStart: number
  gridRowStart: number
}

type GridSlotsProps = {
  slotGrids: SlotGrid[]
  days: Dayjs[]
  people: ScheduledPerson[]
}

export const GridSlots = memo(function GridSlots({
  slotGrids,
  days,
  people,
}: GridSlotsProps) {
  return (
    <>
      {slotGrids.map((slotData) => {
        const { slot, key, dayIndex, groomerKey, gridColumnStart, gridRowStart } = slotData
        const isLastColumn = people.length > 0
          ? (dayIndex !== days.length - 1 || groomerKey !== people.length - 1)
          : (dayIndex !== days.length - 1)

        return (
          <div
            key={key}
            style={{
              gridColumnStart,
              gridRowStart: gridRowStart + ROW_OFFSET,
            }}
            className={cn(
              'w-full bg-surface border-b border-border hover:bg-bg-subtle',
              {
                'border-r': isLastColumn,
                'border-b-border': slot.finish.minute() === 0,
              },
            )}
          >
            <CalendarSlot data={slot} />
          </div>
        )
      })}
    </>
  )
})
